import { render } from "./ResumePanel.vue?vue&type=template&id=149b387c&scoped=true"
import script from "./ResumePanel.vue?vue&type=script&lang=js"
export * from "./ResumePanel.vue?vue&type=script&lang=js"

import "./ResumePanel.vue?vue&type=style&index=0&id=149b387c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149b387c"]])

export default __exports__